import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import CcTextField from "./CcTextField";
import { CC_INPUT_MIN_HEIGHT } from "./CcFieldLayout";
import { cx } from "../utils";

/** Inline compact shell — cannot be overridden by stale MUI select padding. */
const compactInputRootStyle = {
  height: CC_INPUT_MIN_HEIGHT,
  maxHeight: CC_INPUT_MIN_HEIGHT,
  overflow: "hidden",
  boxSizing: "border-box",
};

/** Dense vertical padding — same approach as glass DropdownField. */
const compactSelectDisplayStyle = {
  paddingTop: 8,
  paddingBottom: 8,
  minHeight: 0,
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  lineHeight: 1.25,
};

/**
 * MUI select built on CcTextField.
 *
 * @example
 * <CcSelect label="Status" value={v} onChange={e => setV(e.target.value)}>
 *   <MenuItem value="draft">Draft</MenuItem>
 * </CcSelect>
 */
const CcSelect = React.forwardRef(
  (
    { children, SelectProps, InputProps, className, inputClassName, ...props },
    ref,
  ) => {
    const { MenuProps, SelectDisplayProps, ...restSelectProps } =
      SelectProps || {};
    const { style: inputStyle, ...restInputProps } = InputProps || {};

    const mergedSelectProps = {
      ...restSelectProps,
      SelectDisplayProps: {
        ...SelectDisplayProps,
        style: {
          ...compactSelectDisplayStyle,
          ...SelectDisplayProps?.style,
        },
      },
      MenuProps: {
        getContentAnchorEl: null,
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
        ...MenuProps,
        PaperProps: {
          ...MenuProps?.PaperProps,
          className:
            `cc-select-menu ${MenuProps?.PaperProps?.className ?? ""}`.trim(),
        },
      },
    };

    return (
      <CcTextField
        ref={ref}
        select
        className={className}
        inputClassName={cx("cc-select-control", inputClassName)}
        SelectProps={mergedSelectProps}
        InputProps={{
          ...restInputProps,
          style: {
            ...compactInputRootStyle,
            ...inputStyle,
          },
        }}
        {...props}
      >
        {children}
      </CcTextField>
    );
  },
);

CcSelect.displayName = "CcSelect";

export { MenuItem };

export default CcSelect;
